export const capitalise0 = (text) =>
	text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
